import { Flex, Text } from '@qga/roo-ui/components';

import Skeleton, { SkeletonProvider } from '@shared/v2/components/Skeleton';

import Button from '@/components/Button';
import { useRoomOptionsData } from '@/v2/components/pages/PackageView/contexts/RoomOptionsContext';
import useCtaButton from '@/v2/components/pages/PackageView/hooks/useCtaButton';
import useCtaButtonStatus from '@/v2/components/pages/PackageView/hooks/useCtaButtonStatus';
import Price from './components/Price';

const HeaderCta = () => {
  const buttonStatus = useCtaButtonStatus();
  const { handleClick, buttonText } = useCtaButton(buttonStatus);
  const { isLoading } = useRoomOptionsData() || {};

  if (!buttonStatus) {
    return null;
  }

  return (
    <SkeletonProvider isLoading={isLoading}>
      <Flex
        display={['none', 'none', 'flex']}
        gap={4}
        maxWidth="20rem"
        width="100%"
        flexDirection="column"
      >
        <Price buttonStatus={buttonStatus} />
        {/* @ts-ignore - width is valid but not picked up with roo component */}
        <Skeleton.Button width="100%">
          <Button py="10px" variant="primary" onClick={handleClick}>
            <Text
              display="block"
              lineHeight="1.5"
              fontWeight="bold"
              fontSize="sm"
            >
              {buttonText}
            </Text>
          </Button>
        </Skeleton.Button>
      </Flex>
    </SkeletonProvider>
  );
};

export default HeaderCta;
